import { render } from "./JudgeTable.vue?vue&type=template&id=4d3788a2&scoped=true"
import script from "./JudgeTable.vue?vue&type=script&lang=js"
export * from "./JudgeTable.vue?vue&type=script&lang=js"

import "./JudgeTable.vue?vue&type=style&index=0&id=4d3788a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d3788a2"]])

export default __exports__